<template>
  <div>
    <app-header />
    <div class="index">
      <div class="content">
        <div class="page-contain w1200">
          <div class="box">
            <div class="left">
              <ul class="left-cont">
                <li
                  v-for="(it, index) in leftTabList"
                  :key="index"
                  class="item"
                  :class="[{ active: it.activeLi == $route.meta.leftbar }, {'current-text' : it.activeLi === $route.meta.foldbar}]"
                >
                  <div
                    class="parent-item"
                    @click.stop="routeMethod(it)"
                  >
                    <img
                      :src="it.foldbar == $route.meta.foldbar ? it.iconActive : it.icon"
                      alt=""
                    >
                    <span class="item-lable">{{ it.label }}</span>
                    <span :class="[{'el-icon-arrow-up' : it.activeLi === 'reportParent' && it.child},
                               {'el-icon-arrow-down' : !isShowChild && it.child}]" />
                  </div>
                  <!-- <ul
                    v-if="isShowChild"
                    class="li"
                  >
                    <li
                      v-for="(item, index) in it.child"
                      :key="index"
                      class="item child-item"
                      :class="[{active : item.activeLi == $route.meta.leftbar}]"
                      @click.stop="$router.push(item.path)"
                    >
                      {{ item.label }}
                    </li>
                  </ul> -->
                </li>
              </ul>
            </div>
            <div class="right">
              <div class="mMain">
                <router-view />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/appHeader";
import { mapGetters } from "vuex";
export default {
  components: { AppHeader },
  props: {},
  data () {
    return {
      leftTabList: [],
      isShowChild: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {},
  created () {
    this.changeLeft();
  },
  mounted () { },
  methods: {
    changeLeft () {
      this.leftTabList = [
        {
          label: "量表列表",
          path: "/measure/inventoryList",
          icon: require("@/assets/images/icon1.png"),
          iconActive: require("@/assets/images/iconActive1.png"),
          foldbar: "list", // 是否折叠
          activeLi: "list",
        },
        {
          label: "任务管理",
          path: `/measure/taskManagement/list?tabs=area`,
          icon: require("@/assets/images/icon2.png"),
          iconActive: require("@/assets/images/iconActive2.png"),
          foldbar: "task",
          activeLi: "task",
        },
        {
          label: "预警关注",
          path: "/measure/crisisWarning",
          icon: require("@/assets/images/icon3.png"),
          iconActive: require("@/assets/images/iconActive3.png"),
          foldbar: "crisis",
          activeLi: "crisis",
        },
        {
          label: "报告管理",
          path: "/measure/reportManagement",
          icon: require("@/assets/images/icon4.png"),
          iconActive: require("@/assets/images/iconActive4.png"),
          foldbar: "reportParent",
          activeLi: "reportParent",
          // child: [{
          //   label: "学生报告",
          //   path: "/measure/reportManagement",
          //   activeLi: "report",
          // }],
        },
      ];
    },
    routeMethod (it) {
      // if (it.child) {
      //   this.isShowChild = !this.isShowChild;
      // } else {
      //   this.$router.push(it.path);
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.index {
  background: #f4f5f7;
  height: 100%;
  .content {
    display: flex;
    width: 100%;
    min-height: calc(100% - 112px);
    margin: 0 auto;
    // overflow: auto;
    .page-contain {
      width: 100%;
      margin: 0 auto;
      &.w1200 {
        padding: 16px 0;
        width: 1200px;
      }
    }
  }
}
.box {
  position: relative;
  background: #f4f5f7;
  .left {
    padding-top: 8px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    width: 240px;
    border-radius: 4px;
    background: #fff;
    overflow-x: hidden;
    .left-cont {
      padding: 0 8px;
    }
  }
  .right {
    padding-left: 254px;
    min-height: calc(100vh - 55px);
  }
  .mMain {
    background-color: #f4f5f7;
    border-radius: 4px;
    min-height: calc(100vh - 55px);
  }
}
.item {
  margin-bottom: 8px;
  position: relative;
  font-size: 14px;
  line-height: 40px;
  color: #262626;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  img {
    margin-left: 18px;
    margin-right: 6px;
    width: 16px;
    height: 16px;
    position: relative;
    top: 3px;
  }
  .item-lable {
    display: inline-block;
    width: calc(100% - 41px);
  }
}
.parent-item {
  margin-bottom: 8px;
}
.child-item,
.parent-item {
  border-radius: 4px;
  &:hover {
    background: #f6f7fa;
  }
}
.active {
  // background: #ecf4ff;
  color: #368fff;
}
.li {
  li {
    padding-left: 40px;
  }
  .active {
    position: relative;
    background: #ecf4ff;
    color: #368fff;
    // border-left: 2px solid #368fff;
    &::after {
      content: '';
      display: inline-block;
      width: 2px;
      height: 16px;
      background: #368fff;
      position: absolute;
      top: 12px;
      right: 0;
    }
  }
}
.current-text {
  color: #368fff;
}
.el-icon-arrow-up,
.el-icon-arrow-down {
  position: absolute;
  right: 24px;
  top: 14px;
  font-size: 12px;
  color: rgba(138, 146, 169, 1);
}
</style>
